window.addEventListener('load', function () {

  // ----------------------------
  // URLパラメータで定期購入選択
  // ----------------------------

  const params = new URLSearchParams(window.location.search);

  if (params.get('subscription') === 'true') {

    setTimeout(function () {

      const radios = document.querySelectorAll('input[type="radio"]');

      const subscriptionRadio = [...radios].find(radio => {

        const parent = radio.closest('label, div');

        return parent && parent.textContent.includes('定期');

      });

      if (subscriptionRadio) {
        subscriptionRadio.click();
      }

    }, 0);

  }

  // ----------------------------
  // 一度限りの購入 文言変更
  // ----------------------------

  const path = window.location.pathname;

  let replaceLabel = '通常購入';

  if (
    path.includes('balancing-lotion-3month') ||
    path.includes('extra-moist-cream-3month')
  ) {
    replaceLabel = '通常購入（3本セット）';
  }

  const replaceText = () => {

    document.querySelectorAll(
      '.shopify_subscriptions_app_block_label label'
    ).forEach(label => {

      if (
        label.textContent.includes('一度限りの購入')
      ) {

        label.childNodes.forEach(node => {

          if (
            node.nodeType === Node.TEXT_NODE &&
            node.textContent.includes('一度限りの購入')
          ) {

            node.textContent =
              node.textContent.replace(
                '一度限りの購入',
                replaceLabel
              );

          }

        });

      }

    });

  };

  setTimeout(replaceText, 0);
  setTimeout(replaceText, 1000);
  setTimeout(replaceText, 2000);

});


window.addEventListener('load', function () {

  function updateSubscriptionPrice() {

    // -------------------------
    // 定期購入判定
    // -------------------------

    const sellingPlanInput = document.querySelector(
      '.selected-selling-plan-id'
    );

    const isSubscription =
      sellingPlanInput &&
      sellingPlanInput.value !== '';

    // -------------------------
    // URL取得
    // -------------------------

    const path = window.location.pathname;

    // -------------------------
    // 通常価格
    // -------------------------

    let normalPrice = '6,600';

    let subscriptionPrice = '';

    // -------------------------
    // 商品ごと価格変更
    // -------------------------

    if (
      path.includes('balancing-lotion-3month') ||
      path.includes('extra-moist-cream-3month')
    ) {

      normalPrice = '19,800';
      subscriptionPrice = '13,860';

    }

    else if (
      path.includes('balancing-lotion') ||
      path.includes('extra-moist-cream')
    ) {

      normalPrice = '6,600';
      subscriptionPrice = '4,620';

    }

    // -------------------------
// 表示価格決定
// -------------------------

let displayPrice = '';

if (isSubscription) {

  displayPrice =
    `<span class="subscription-price"><span>${subscriptionPrice}</span>円（税込）<small>※初回は30％OFF</small><span>`;

}

else {

  displayPrice =
    `<span>${normalPrice}</span>円（税込）`;

}

// -------------------------
// 価格表示書換
// -------------------------

document.querySelectorAll('[data-product-price]')
  .forEach(el => {

    el.innerHTML = displayPrice;

  });

  }

  // -------------------------
  // 初回実行
  // -------------------------

  setTimeout(updateSubscriptionPrice, 1000);

  // -------------------------
  // radio変更時
  // -------------------------

  document.addEventListener('change', function (e) {

    if (
      e.target.matches('input[data-radio-type]')
    ) {

      setTimeout(updateSubscriptionPrice, 50);

    }

  });

});